import psHttp, { RequestChannel, psHttp$ } from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix, lifeScienceApiUrlPrefix } from '../../config/constants';

const fetchChannelWorkspace = new RequestChannel(psHttp$);
const queryPreviewChannel = new RequestChannel(psHttp$);


/**
 * 复制专利
 */
export function copyPatentsApi({
    space_id,
    from_folder_id,
    family_type,
    patent_ids,
    refiner,
    select_mode,
    to_folder_id,
    range_from,
    range_to,
    sort,
    copy_field_comment_request
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/from_folder/${from_folder_id}/copy-patents`,
        method: 'POST',
        data: {
            family_type,
            patent_ids,
            refiner,
            select_mode,
            to_folder_id,
            start: range_from,
            end: range_to,
            sort,
            copy_field_comment_request
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 移动专利
 */
export function movePatentsApi({
    space_id,
    from_folder_id,
    family_type,
    patent_ids = [],
    refiner = {},
    select_mode,
    to_folder_id,
    range_from,
    range_to,
    sort,
    copy_field_comment_request
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/from_folder/${from_folder_id}/move-patents`,
        method: 'POST',
        data: {
            family_type,
            patent_ids,
            refiner,
            select_mode,
            to_folder_id,
            start: range_from,
            end: range_to,
            sort,
            copy_field_comment_request
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 删除专利
 */
export function deletePatentsApi({
    space_id,
    folder_id,
    family_type,
    patent_ids = [],
    refiner = {},
    select_mode,
    range_from,
    range_to,
    sort,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/delete-patents`,
        method: 'DELETE',
        data: {
            family_type,
            patent_ids,
            refiner,
            select_mode,
            start: range_from,
            end: range_to,
            sort,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 拖拽专利
 */
export function dragPatentsApi({
    space_id,
    from_folder_id,
    family_type,
    patent_ids = [],
    refiner = {},
    select_mode,
    to_folder_id,
    range_from,
    range_to,
    sort,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/from_folder/${from_folder_id}/drag-patents`,
        method: 'POST',
        data: {
            family_type,
            patent_ids,
            refiner,
            select_mode,
            to_folder_id,
            start: range_from,
            end: range_to,
            sort,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 更新专利已读未读状态
 */
export function updatePatentReadStatusApi({
    folder_id,
    patent_ids = [],
    refiner = {},
    select_mode,
    read_status,
    range_from,
    range_to,
    sort,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/update-patent-read-status`,
        method: 'POST',
        data: {
            patent_ids,
            refiner,
            select_mode,
            read_status,
            start: range_from,
            end: range_to,
            sort,
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 预览专利
 */
export function previewPatentApi({ count_type, space_id, folder_id, q, efq, stem_on, valid_dbs, cal_folder_ids, cal_merge_type }) {
    return queryPreviewChannel.requestAsPromise({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/preview-patent`,
        method: 'POST',
        transformCode: true,
        data: {
            count_type,
            space_id,
            folder_id,
            q,
            efq,
            stem_on,
            valid_dbs,
            cal_folder_ids,
            cal_merge_type,
        }
    }).then(({ data }) => {
        return data || {};
    });
}

/**
 * 保存到工作空间-没有自动更新
 */
export function savePatentsApi({ space_id, folder_id, payload }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/patents`,
        method: 'PUT',
        transformCode: true,
        data: payload
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 保存到工作空间-有自动更新
 */
export function addPatentsByQueryApi({ space_id, folder_id, payload }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/add-patents-by-query`,
        method: 'POST',
        transformCode: true,
        data: payload
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 查询扩展匹配数量
 */
export function familyExpansionCountApi({ payload }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/family-expansion-count`,
        method: 'POST',
        transformCode: true,
        data: payload
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取专利注释和自定义字段
 */
export function getPatentCommentsAndFieldsApi({
    folder_id,
    with_comment,
    patent_ids = [],
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/patent-detail`,
        method: 'POST',
        transformCode: true,
        params: {
            with_comment,
        },
        data: patent_ids
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取反选专利id列表
 */
export function getExcludePatentIdsApi({
    folder_id,
    patent_ids,
    refiner,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/get-exclude-patent-ids`,
        method: 'POST',
        transformCode: true,
        data: {
            patent_ids,
            refiner,
        },
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 获取专利预览信息 (鼠标hover弹窗)
 */
export function previewPatentInfoApi({
    space_id,
    patent_id,
    folder_id,
    sort,
    qid,
    stem,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/patent/${patent_id}/preview`,
        method: 'GET',
        params: {
            folder_id,
            sort,
            qid,
            stem,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * 长短query转换
 */
export function getShortQueryApi({
    space_id,
    folder_id,
    wq,
    wefq,
    conditions
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/short-query`,
        method: 'POST',
        transformCode: true,
        data: {
            space_id,
            folder_id,
            wq,
            wefq,
            conditions
        }
    }).then(({ data }) => {
        return data.data || {};
    });
}

/**
 * getPatentListV3Api
 *
 * @param {*} param0
 */
export function getPatentListV3Api({
    space_id,
    folder_id,
    cond,
    efqid,
    is_init,
    page,
    qid,
    sort,
    standard_only,
    view_type,
    stem,
    range_params,
    collapse,
    ai_field_id,
}) {
    return fetchChannelWorkspace.requestAsPromise({
        url: `${workspaceApiUrlPrefix}/${space_id}/folder/${folder_id}/patents`,
        method: 'POST',
        transformCode: true,
        data: {
            space_id,
            folder_id,
            page,
            is_init,
            sort,
            view_type,
            qid,
            efqid,
            cond,
            standard_only,
            stem,
            range_params,
            collapse,
            ai_field_id,
        }
    }).then(({ data }) => {
        return data || [];
    });
}

export function getSearchCitationQueryApi({
    folder_id,
    cite_type,
    patent_ids,
    refiner,
    select_mode,
    sort,
    start,
    end,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/qid-by-mode`,
        method: 'POST',
        transformCode: true,
        data: {
            cite_type,
            patent_ids,
            refiner,
            select_mode,
            sort,
            start,
            end,
        },
    }).then(({ data }) => {
        return data.data || [];
    });
}

/**
 * 获取范围选择专利id列表
 */
export function getRangePatentIdsApi({
    folder_id,
    sort,
    qid,
    efqid,
    range_from,
    range_to,
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/folder/${folder_id}/get-range-patent-ids`,
        method: 'POST',
        transformCode: true,
        data: {
            folder_id,
            sort,
            qid,
            efqid,
            start: range_from,
            end: range_to,
        },
    }).then(({ data }) => {
        return data.data || [];
    });
}

export function markWorkspaceApi({
    folder_id,
    patent_ids
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/patent/mark/workspace`,
        method: 'POST',
        data: {
            folder_id,
            patent_ids,
            type: 'read'
        },
    });
}

export function getBIOTargetSequenceApi({ sequence_number, bio_uk }) {
    return psHttp({
        url: `${lifeScienceApiUrlPrefix}/workspace/${sequence_number}/query`,
        method: 'POST',
        data: {
            bio_uk
        }
    }).then(({ data }) => {
        return data || {};
    });
}


export function getWordCloudApi({
    folder_id,
    word_cloud_fields = [],
    refiner,
    sort,
    lang = 'cn'
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/lab/word-cloud/workspace/folder/${folder_id}`,
        method: 'POST',
        data: {
            word_cloud_fields,
            refiner,
            sort,
            patent_ids: [],
            select_mode: 'RANGE',
            start: 1,
            end: 5000,
        },
        params: { lang }
    }).then(({ data }) => {
        return data || {};
    });
}

export function getWordCloudListApi(data) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/lab/word-cloud/patent/detail`,
        method: 'POST',
        params: data,
    }).then(({ data }) => {
        return data || {};
    });
}

export function getWsFullImagesApi ({ type = 'srp', limit, page = 1, patentId, count, workspace_id, folder_id }) {
    const params = {
        type,
        limit,
        page,
        patentId,
        // 以下属性lab图片注释需要用到
        workspace_id,
        folder_id
    };
    if (type === 'view' && count) {
        params.patent_image_count = count;
    }
    return psHttp({
        url: `${workspaceApiUrlPrefix}/patent/view/get_full_images`,
        method: 'GET',
        params,
        transformCode: true
    });
}

export function getCopyPermissionAndSetting({
    dst_folder_id,
    dst_space_id,
    src_folder_ids,
    src_space_id,
    viewType,
    copy_move_folder_type
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/copy/data/permission-display-setting-info?view_type=${viewType}`,
        method: 'POST',
        transformCode: true,
        data: {
            dst_folder_id,
            dst_space_id,
            src_folder_ids,
            src_space_id,
            copy_move_folder_type,
        },
    }).then(({ data }) => {
        return data || [];
    });
}

export function getFieldDetailByFieldId ({ space_id, folder_id, field_id }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/copy/data/space/${space_id}/folder/${folder_id}/field/${field_id}`,
        method: 'GET',
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}
